import type { Brand } from '~/types/user';

import type { DialogHandles } from '../BrandsTable.hooks';

import { mobileActionsStyle, mobileCellStyle, mobileHeaderStyle } from './brandCell.css';
import { BrandColorCell } from './BrandColorCell';
import { BrandEmailCell } from './BrandEmailCell';
import { BrandNameCell } from './BrandNameCell';
import { BrandOptionsCell } from './BrandOptionsCell';

type Props = {
  brand: Brand;
  dialogHandles: DialogHandles;
};

export const BrandMobileCell = ({ brand, dialogHandles }: Props) => {
  return (
    <div className={mobileCellStyle}>
      <div className={mobileHeaderStyle}>
        <BrandNameCell brand={brand} />

        <BrandEmailCell email={brand.email} />
      </div>

      <div className={mobileActionsStyle}>
        <BrandColorCell brand={brand} />

        <BrandOptionsCell brand={brand} dialogHandles={dialogHandles} />
      </div>
    </div>
  );
};
